import { render } from "./MobileHeaderComponent.vue?vue&type=template&id=68a2a8c1&scoped=true"
import script from "./MobileHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MobileHeaderComponent.vue?vue&type=script&lang=js"

import "./MobileHeaderComponent.vue?vue&type=style&index=0&id=68a2a8c1&scoped=true&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a2a8c1"]])

export default __exports__